var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dragArea",staticClass:"drag-area",class:{
    visible: _vm.showDragArea,
    hover: _vm.hoverDragArea,
    commentVisible: _vm.isCommentEditorShowing,
  },on:{"click":function($event){_vm.showDragArea = false}}},[_c('div',{staticClass:"drag-content"},[_c('FileIcon'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('Drag and drop files here')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }